import React, { useEffect, useState } from "react";

/**
 * Full-bleed hero background: a slow crossfade between photographs, each one
 * drifting (zoom + pan) the whole time so the ground never sits still.
 *
 * The first slide is the LCP image, so it keeps its WebP/JPEG pair and loads
 * eagerly at high priority; the rest are plain decorative images. Under
 * `prefers-reduced-motion` the first slide is shown alone and nothing moves.
 */
const SLIDES = [
  { src: "/images/bags-warehouse.jpg", webp: "/images/bags-warehouse.webp" },
  { src: "/images/bg/chemical-storage-containers.jpeg" },
  { src: "/images/bg/shipping-containers-port.webp" },
  { src: "/images/bg/warehouse-sacks.webp" },
  { src: "/images/bg/lab-glassware.webp" },
];

const HOLD_MS = 7000;

const HeroSlideshow = () => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;

    const id = window.setInterval(() => {
      if (!document.hidden) setActive((i) => (i + 1) % SLIDES.length);
    }, HOLD_MS);
    return () => window.clearInterval(id);
  }, []);

  return (
    <div className="hero__media" aria-hidden="true">
      {SLIDES.map((slide, i) => {
        const img = (
          <img
            src={slide.src}
            alt=""
            {...(i === 0
              ? { width: 1800, height: 1200, loading: "eager", fetchPriority: "high" }
              : {})}
            decoding="async"
          />
        );

        return (
          <div
            key={slide.src}
            className={`hero__slide hero__slide--${i % 3}${i === active ? " is-active" : ""}`}>
            {slide.webp ? (
              <picture>
                <source srcSet={slide.webp} type="image/webp" />
                {img}
              </picture>
            ) : (
              img
            )}
          </div>
        );
      })}
    </div>
  );
};

export default HeroSlideshow;
